import { log, supabase } from ".";

export const deleteCliente = async (id) => {
  try {
    const data = await supabase.update("clientes", { eliminada: true }, id);

    if (!data || data.length === 0) throw new Error("Empty response");

    return data;
  } catch (error) {
    log.error("deleteCliente", error);
    throw error;
  }
};
